import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Form, Field } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class Edit extends React.Component {
	@observable record = null;
	@observable error = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Convocation.findById(this.id);
			} catch (e) {
				this.error = e.message;
			}
		} else {
			this.record = new store.model.Convocation();
		}
	};

	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;

		return (
			<>
				<p>Созыв</p>
				<Form
					record={this.record}
					rootPath="/admin"
					returnTo="/admin/convocations"
					disabled={!this.record.startDate || !this.record.endDate}
					noDelete
				>
					<Field property="name" label="Наименование" />
					<Field property="validity" label="Период работы" />
					<Field property="current" label="Текущий" />
					<Field property="startDate" label="Начало работы" isRequired />
					<Field property="endDate" label="Конец работы" isRequired />
				</Form>
			</>
		);
	}
}
